module.exports = __webpack_public_path__ + "static/media/orange.f8456837.png";